import { css } from 'linaria';

export const calculateQuantityButton = css`
  width: 100%;
  margin-bottom: var(--space-200);
`;
